import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@cotyorg/ccx-atoms/Input';
import Button from '@cotyorg/ccx-atoms/Button';
import useScript from '@cotyorg/ccx-utils/js/hooks/useScript';
import IconButton from '../../../IconButton';

export const generateNewsletterInputClassNames = ({ success, error, buttonType }) => classNames(
  'input',
  'newsletter__input',
  'flex-child-auto',
  {
    'newsletter__input--success': success,
    'newsletter__input--error': error,
    'newsletter__input--with-icon': buttonType === 'icon',
  },
);

export const generateNewsletterMessageClassNames = ({ success, error }) => classNames(
  'newsletter__message',
  {
    'newsletter__message--success': success,
    'newsletter__message--error': error,
  },
);

const getHandleFormSubmit = ({
  requestStart,
  url,
  data,
  emailDataKey,
}) => (e) => {
  e.preventDefault();
  const email = e.target.email.value;
  const dataWithEmail = {
    ...data,
    [emailDataKey]: email,
  };

  requestStart({
    url,
    data: dataWithEmail,
  });
};

const getHandleInput = ({
  setInputValue,
}) => (e) => {
  setInputValue(e.target.value);
};

const Newsletter = ({
  requestStart,
  errorMessage,
  successMessage,
  pending,
  success,
  error,
  placeholderMessage,
  submitButtonText,
  buttonIconSrc,
  buttonType = 'default',
  url = '/',
  data = {},
  emailDataKey = 'email',
  value,
  setInputValue,
  testAttribute = 'newsletter-submit',
  iconWidth = 16,
  iconHeight,
  isKlaviyoEnabled,
  klaviyoScriptUrl,
  klaviyoContainerClass,
}) => {
  useScript(klaviyoScriptUrl);
  return (
    <Fragment>
      {isKlaviyoEnabled ?
        <div className={klaviyoContainerClass} />
    : (
      <div>
        <div className="newsletter">
          <form
            className="newsletter__form flex-container flex-dir-column medium-flex-dir-row flex-child-auto"
            onSubmit={getHandleFormSubmit({
              requestStart,
              url,
              data,
              emailDataKey,
            })}
          >

            <Input
              testAttribute="newsletter-input"
              ariaLabel={placeholderMessage}
              extraClass={generateNewsletterInputClassNames({ success, error, buttonType })}
              placeholder={placeholderMessage}
              type="email"
              name="email"
              required
              value={value}
              onInput={getHandleInput({ setInputValue })}
            />

            {buttonType === 'default' ? (
              <Button
                testAttribute={testAttribute}
                extraClass="newsletter__button button--primary"
                theme="primary"
              >
                {submitButtonText}
              </Button>
            ) : (
              <IconButton
                testAttribute={testAttribute}
                extraClass="newsletter__button newsletter__button--icon button--clear"
                color="transparent"
                iconSrc={buttonIconSrc}
                iconWidth={iconWidth}
                iconHeight={iconHeight}
              />
            )}
          </form>
        </div>
        {pending && <span>Loading...</span>}

        <div className={generateNewsletterMessageClassNames({ success, error })}>
          {error && <span>{errorMessage}</span>}
          {success && <span>{successMessage}</span>}
        </div>
      </div>
    )}
    </Fragment>
  );
};

Newsletter.propTypes = {
  requestStart: PropTypes.func.isRequired,
  pending: PropTypes.bool,
  errorMessage: PropTypes.shape({
    number: PropTypes.number,
    string: PropTypes.string,
  }),
  successMessage: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  placeholderMessage: PropTypes.string,
  submitButtonText: PropTypes.string,
  buttonIconSrc: PropTypes.string,
  buttonType: PropTypes.oneOf(['default', 'icon']),
  url: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  emailDataKey: PropTypes.string,
  setInputValue: PropTypes.func.isRequired,
  value: PropTypes.string,
  testAttribute: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  isKlaviyoEnabled: PropTypes.bool,
  klaviyoScriptUrl: PropTypes.string,
  klaviyoContainerClass: PropTypes.string,
};

export default Newsletter;
